<xemex-card-grid>
  <xemex-card [title]="'companies.detailTabs.general.label' | translate">
    <div class="grid grid-cols-2 gap-4">
      <xemex-detail-field
        [label]="'companies.detailTabs.general.vat' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerVat }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.kvk' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerChamberOfCommerceNo }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.city' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerCity }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.zipcode' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerPostalcode }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.country' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerCountry }}
      </xemex-detail-field>
      @if (isXemex() || isOwnPartner()) {
        <xemex-detail-field
          [label]="'companies.detailTabs.general.adminEmail' | translate"
          [loading]="isLoading()"
        >
          {{ companyDetail()?.partnerEmail }}
        </xemex-detail-field>
      }
    </div>
  </xemex-card>

  @if (showPartnerSettings()) {
    <xemex-card [title]="'companies.detailTabs.general.partnerSettings.title' | translate">
      <div class="grid grid-cols-2 gap-4">
        <xemex-detail-field
          [label]="'companies.detailTabs.general.defaultMeterRole.label' | translate"
          [loading]="isLoading()"
        >
          @if (companyDetail()?.partnerDefaultMeterRole; as role) {
            {{ 'meterRoles.' + role | translate }}
          }
        </xemex-detail-field>
        <xemex-detail-field
          [label]="'companies.detailTabs.general.dataReadout.frequency' | translate"
          [loading]="isLoading()"
        >
          {{ readoutFrequency().key | translate: readoutFrequency().params }}
        </xemex-detail-field>
      </div>
    </xemex-card>
  }
</xemex-card-grid>
